import { requests } from '.'

export const CompanyService = {
  getById: (companyId: string) => requests().get('/companies/' + companyId),
  update: (companyId: string, company: { rollupAutoScheduleEnabled?: boolean }) =>
    requests().put(`/companies/${companyId}`, {
      ...company,
    }),
}
